import { atom, selector } from 'recoil'

import type { ModalSendConfirmationEmailState } from 'Pages/RecipientsList/model'

export const modalSendConfirmationState = atom<ModalSendConfirmationEmailState>(
  {
    key: 'recipientsList_modalSendConfirmationState',
    default: {
      show: false,
      idRecipient: 0,
      contact: '',
      idConfirmationMessage: 0,
      idConfirmationMessageIsDirty: false,
    },
  },
)

export const modalSendConfirmationHasMessageFeedback = selector<boolean>({
  key: 'recipientsList_modalSendConfirmationHasMessageFeedback',
  get: ({ get }) => {
    const { idConfirmationMessage, idConfirmationMessageIsDirty } = get(
      modalSendConfirmationState,
    )

    return (
      (idConfirmationMessage === undefined || idConfirmationMessage === null) &&
      idConfirmationMessageIsDirty
    )
  },
})

export const modalSendConfirmationSubmitDisabledState = selector<boolean>({
  key: 'recipientsList_modalSendConfirmationSubmitDisabledState',
  get: ({ get }) => {
    const { idConfirmationMessage, idRecipient } = get(
      modalSendConfirmationState,
    )

    return !(idConfirmationMessage > 0 && idRecipient > 0)
  },
})
